import React from "react";
import "./PageHeader.css";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface PageHeaderProps {
  title: string;
  breadcrumbs: BreadcrumbItem[];
  rightContent?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  breadcrumbs,
  rightContent,
}) => {
  return (
    <div className="page-header">
      {/* LEFT : TITLE */}
      <h1 className="page-title">{title}</h1>

      {/* RIGHT : BREADCRUMB + ACTIONS */}
      <div className="page-header-right">
        <div className="breadcrumbs">
          {breadcrumbs.map((item, index) => (
            <span key={index} className="breadcrumb-item">
              {index > 0 && (
                <span className="breadcrumb-separator">/</span>
              )}
              {item.label}
            </span>
          ))}

        </div>

        {rightContent && (
          <div className="page-actions">{rightContent}</div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;